import { AppCard, AppSearchBox } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Briefcase, FileText, Target } from 'lucide-react'
import { useMemo, useState } from 'react'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { type User, useAuthStore } from '@/stores/auth'

export const Route = createFileRoute('/_authenticated/')({
  component: HomePage,
})

interface AppItem {
  title: string
  description: string
  path: string
  icon: React.ReactNode
  isVisible?: (user: User) => boolean
}

const apps: AppItem[] = [
  {
    title: 'オポチュニティ管理',
    description: 'オポチュニティの登録管理を行います。',
    path: '/opportunities',
    icon: <Target className='w-16 h-16' />,
  },
  {
    title: '引合管理',
    description: '引合の登録管理を行います。',
    path: '/inquiries',
    icon: <FileText className='w-16 h-16' />,
    isVisible: (user) => user.acl.inquiry !== null || user.acl.administrator,
  },
  {
    title: 'アサインAIマッチング',
    description: 'AIを活用したアサインマッチングを行います。',
    path: '/',
    icon: <Briefcase className='w-16 h-16' />,
  },
]

function HomePage() {
  useDocumentTitle('オポチュニティポータル')
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const [searchQuery, setSearchQuery] = useState('')

  const filteredApps = useMemo(() => {
    if (!user) return []
    const visibleApps = apps.filter((app) => !app.isVisible || app.isVisible(user))

    if (!searchQuery) return visibleApps

    const query = searchQuery.toLowerCase()
    return visibleApps.filter(
      (app) => app.title.toLowerCase().includes(query) || app.description.toLowerCase().includes(query),
    )
  }, [searchQuery, user])

  return (
    <div id='home' className='h-full overflow-y-auto'>
      <div className='container mx-auto p-8'>
        <div className='flex justify-center mb-8'>
          <div className='w-full max-w-2xl'>
            <AppSearchBox value={searchQuery} onChange={setSearchQuery} placeholder='検索' />
          </div>
        </div>

        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6'>
          {filteredApps.map((app) => (
            <AppCard key={app.title} title={app.title} onClick={() => navigate({ to: app.path })}>
              <div className='flex items-center justify-center min-h-25'>{app.icon}</div>
            </AppCard>
          ))}
        </div>

        {filteredApps.length === 0 && (
          <div className='text-center text-muted-foreground mt-8'>
            <p>検索結果がありません</p>
          </div>
        )}
      </div>
    </div>
  )
}
